import { useState, useEffect } from "react";
import { useCustomSearchData } from "@redux/slices/searchResultsCustomization";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { ProductCategory } from "@utils/constants";
import {
  SearchFilterTypeEnum,
  SearchFilterTypeEnumLowercase,
} from "@components/atoms/Filters/utils";

export const useDisplayRetailPrice = (
  productType: ProductCategory,
  sectionName: SearchFilterTypeEnum = SearchFilterTypeEnum.SINGLE_STONES
) => {
  const [displayRetailPrice, setDisplayRetailPrice] = useState(false);
  const customSearchData = useCustomSearchData();
  const userInfo = useUserInfo();
  const priceMode = userInfo?.user?.price_mode;

  useEffect(() => {
    const gridViewData = customSearchData?.[productType]?.grid_view;
    let subSectionOptions = {};
    switch (sectionName) {
      case SearchFilterTypeEnum.SINGLE_STONES:
        subSectionOptions = gridViewData?.["sub-sections"] ?? {};
        break;
      case SearchFilterTypeEnum.PAIRS:
        subSectionOptions =
          gridViewData &&
          gridViewData["sub-sections"]?.[SearchFilterTypeEnumLowercase.PAIRS]
            ? gridViewData["sub-sections"]?.[
                SearchFilterTypeEnumLowercase.PAIRS
              ]
            : gridViewData["sub-sections"];
        break;
      default:
        subSectionOptions = gridViewData?.["sub-sections"] ?? {};
        break;
    }
    if (
      subSectionOptions &&
      subSectionOptions?.price_section?.options?.retail_price
    ) {
      const retailPriceOption =
        subSectionOptions?.price_section.options.retail_price;
      setDisplayRetailPrice(retailPriceOption.price_modes.includes(priceMode));
    } else {
      setDisplayRetailPrice(false);
    }
  }, [
    customSearchData?.[productType]?.grid_view,
    productType,
    priceMode,
    sectionName,
  ]);

  return displayRetailPrice;
};
